import classNames from 'classnames';
import { Button } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { TestBem } from '../../../service/TestBem';
import { Shape2, Shape2Icon } from '../../Shape2/Shape2';
import { PhrasesSelectorMinusPhrasesEditForm } from '../PhrasesSelectorMinusPhrasesEditForm/PhrasesSelectorMinusPhrasesEditForm';

import './PhrasesSelectorMinusPhrasesCell.css';

export interface PhrasesSelectorMinusPhrasesCellProps {
    index: number;
    minusPhrase: string;
    onRemove: (index: number) => void;
    onChange: (index: number, phrase: string) => void;
}

interface PhrasesSelectorMinusPhrasesCellState {
    isEdit: boolean;
}

const BLOCK = 'phrases-selector-minus-phrases-cell';

export class PhrasesSelectorMinusPhrasesCell extends React.PureComponent<
    PhrasesSelectorMinusPhrasesCellProps,
    PhrasesSelectorMinusPhrasesCellState
> {
    state = {
        isEdit: false
    };

    render() {
        const { isEdit } = this.state;
        const { minusPhrase } = this.props;

        return (
            <div className={Bem.cls(BLOCK)}>
                {isEdit ? (
                    <PhrasesSelectorMinusPhrasesEditForm
                        phrase={minusPhrase}
                        onSave={this.onPhraseEdit}
                        onCancel={this.onEditToggle}
                    />
                ) : (
                    <>
                        <span
                            className={classNames(Bem.cls(BLOCK, 'phrase'), TestBem.cls(BLOCK, 'phrase'))}
                            title={minusPhrase}
                        >
                            {minusPhrase}
                        </span>
                        <Button
                            theme="clear"
                            size="s"
                            cls={classNames(
                                Bem.cls(BLOCK, 'icon-button', {
                                    action: 'edit'
                                }),
                                TestBem.cls(BLOCK, 'edit-btn')
                            )}
                            onClick={this.onEditToggle}
                        >
                            <Shape2 width={14} height={14} icon={Shape2Icon.edit} />
                        </Button>
                        <Button
                            theme="clear"
                            size="s"
                            cls={classNames(
                                Bem.cls(BLOCK, 'icon-button', {
                                    action: 'remove'
                                }),
                                TestBem.cls(BLOCK, 'remove-btn')
                            )}
                            onClick={this.onRemove}
                        >
                            <Shape2 width={14} height={14} icon={Shape2Icon.trashbin} />
                        </Button>
                    </>
                )}
            </div>
        );
    }

    private onRemove = () => {
        const { index, onRemove } = this.props;

        onRemove(index);
    };

    private onPhraseEdit = (phrase: string) => {
        const { index, onChange } = this.props;

        this.onEditToggle();

        onChange(index, phrase);
    };

    private onEditToggle = () => {
        this.setState(prevState => ({ isEdit: !prevState.isEdit }));
    };
}
